import React from 'react'
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip
} from 'recharts'
import Loader from './loader'

const numberWithCommas = function(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

const Chart = ({ data = [] }) => (
  <>
    {data.length === 0 && (
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <Loader />
      </div>
    )}
    <ResponsiveContainer height={500}>
      <BarChart
        height={500}
        data={data}
        margin={{ top: 5, left: 5, bottom: 5 }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <Bar dataKey="data" fill="#148e9e" />
        <XAxis
          dataKey="name"
          tick={{ angle: -80, fontSize: 13 }}
          height={200}
          textAnchor="end"
          interval={0}
        />
        <YAxis
          tick={{
            fontSize: 10
          }}
          tickCount={8}
          tickFormatter={value => numberWithCommas(value)}
        />
        <Tooltip
          cursor={false}
          formatter={value =>
            `$${numberWithCommas(parseFloat(value.toString()).toFixed(2))}`
          }
        />
      </BarChart>
    </ResponsiveContainer>
  </>
)

export default Chart
